// LLM 调用：模型配置从 IndexedDB 读，经 flask /api/llm 无状态转发。
//
// 密钥、真实 baseURL、模型名全部存在浏览器 IndexedDB（settings.js）。
// ChatOpenAI 的 baseURL 指向本机 flask 的 /api/llm；真实目标 baseURL 通过
// X-Target-Base-URL 头透传，flask 只转发、不存不落库。

import { ChatOpenAI } from '@langchain/openai';
import { getLlmSettings } from './settings.js';

export const LLM_PROXY_URL = '/api/llm';

export async function createModel() {
    const { apiKey, baseURL, modelName, accessToken } = await getLlmSettings();
    if (!apiKey || !baseURL || !modelName) {
        throw new Error('请先配置大模型（API Key / Base URL / 模型名）');
    }
    const target = baseURL.replace(/\/chat\/completions\/?$/i, '').replace(/\/$/, '');
    // 绝对地址：chat iframe 内相对 /api/llm 虽也能用，但 OpenAI SDK 在部分环境下对相对 baseURL 解析不稳。
    const proxyBase = typeof location !== 'undefined'
        ? new URL(LLM_PROXY_URL, location.origin).href.replace(/\/$/, '')
        : LLM_PROXY_URL;
    return new ChatOpenAI({
        model: modelName,
        apiKey,
        temperature: 0.2,
        configuration: {
            baseURL: proxyBase,
            defaultHeaders: {
                'X-Target-Base-URL': target,
                // 默认凭证模式下代理需要登录票据来确认调用方身份；模型供应商不会收到该头。
                ...(accessToken ? { 'X-Muse-Token': accessToken } : {}),
            },
        },
    });
}

export default { createModel, LLM_PROXY_URL };
